// Static
import { BLOCKCHAIN_ICONS } from '../static';
export const getBlockchainIcon = (blockchain) => BLOCKCHAIN_ICONS[blockchain];
